export { configureHttp } from './config.js';
export { getJson, httpClient, postJson } from './client.js';
export { BreakerOpenError, HttpError, TimeoutError } from './error.js';
export { DEFAULT_BREAKER, DEFAULT_RETRY, DEFAULT_TIMEOUT_MS, } from './types.js';
import { _resetBreaker } from './breaker.js';
import { _resetConfig } from './config.js';
/**
 * Reset all module-private state (config + breaker) to defaults.
 * Test-only. Not part of the stable public API.
 */
export function _resetForTesting() {
    _resetConfig();
    _resetBreaker();
}
//# sourceMappingURL=index.js.map